<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid>
			<b-row class="mt-3 mb-2">
				<b-col cols="4">
					<b-img :src="$session.get('weburl')+'/images/'+$session.get('user_info').permissions.logo_left" v-if="$session.get('user_info').permissions.logo_left!=''" fluid alt="Fluid image" style="max-width:100px;" class="my-2"></b-img>
				</b-col>
				<b-col cols="4" class="text-center">
					<h4 class="text-uppercase"><b>Live Tracking</b></h4>
				</b-col>
				<b-col cols="4" class="text-right">
					<b-img :src="$session.get('weburl')+'/images/'+$session.get('user_info').permissions.logo_right" fluid alt="EESL" style="max-width:100px;" class="mr-2"></b-img>
					<b-button variant="dark" pill class="" v-if="$root.chkperm('page_devices','export')"  @click="downloadcsv()">Export</b-button>
				</b-col>
			</b-row>
		</b-container>
		<b-container fluid>
			<b-row class="px-2">
				<b-col class="px-2">
					<b-card img-src="../assets/dcu.svg" img-alt="Card image" img-left class="info-box mb-3">
						<h6>Total Users</h6>
						<b-card-text>
							{{records.length}}
						</b-card-text>
					</b-card>
				</b-col>
				<b-col class="px-2">
					<b-card img-src="../assets/dcu.svg" img-alt="Card image" img-left class="info-box mb-3">
						<h6>Users Connected</h6>
						<b-card-text>
							{{ device_connected }} <small>Nos</small>
						</b-card-text>
					</b-card>
					
				</b-col>
				<b-col class="px-2">
					<b-card img-src="../assets/dcu.svg" img-alt="Card image" img-left class="info-box mb-3 bg-orange">
						<h6>Users Disconnected</h6>
						<b-card-text>
							{{ records.length - device_connected }} <small>Nos</small>
						</b-card-text>
					</b-card>
				</b-col>
				<b-col class="px-2">
					<b-card img-src="../assets/dcu.svg" img-alt="Card image" img-left class="info-box mb-3 bg-green">
						<h6>Moving</h6>
						<b-card-text>
							{{ device_on }} <small>Nos</small>
						</b-card-text>
					</b-card>
					
				</b-col>
			</b-row>
						

			
			<b-container fluid style="display:none">
				<b-row class="my-3">
					<b-col md="12">
						<line-chart ref="livechart"/>
					</b-col>
				</b-row>
			</b-container>
			<b-row class="my-3">
				<b-col>
					<div class="float-left">
						<img src="../assets/flag-green.png" style="width: 20px; max-height:28px;"/>
						<span class="pl-2 text-sm"><b>User Connected</b></span>
					</div>
					<div class="float-left ml-5">
						<img src="../assets/flag-red.png" style="width: 20px; max-height:28px;"/>
						<span class="pl-2 text-sm"><b>User Disconnected</b></span>
					</div>
					<div class="float-left ml-5">
						<img src="../assets/flag-blue.png" style="width: 20px; max-height:28px;"/>
						<span class="pl-2 text-sm"><b>User Offline</b></span>
					</div>
				</b-col>
				<b-col cols="6">
					<span class="float-right text-sm pt-2"><b>LAST SYNC TIME: {{last_sync_time}}</b></span>
				</b-col>
			</b-row>
			<b-row class="my-3">
				<b-col>
					<gmap-map :center="center" :zoom="zoom" class="googlemap" ref="refmap">
						<gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWindowOpen" @closeclick="infoWindowOpen=false"></gmap-info-window>
						<gmap-marker :key="index" v-for="(m, index) in markers1" :position="m.position" :clickable="true" :icon="m.icon" @click="toogleMarkerInfoWindow(m,index)"></gmap-marker>
						<gmap-cluster :gridSize="30" :position="center" :averageCenter="true">
							<gmap-marker :key="index" v-for="(m, index) in markers" :position="m.position" :clickable="true" :icon="m.icon" @click="toogleMarkerInfoWindow(m,index)"></gmap-marker>
						</gmap-cluster>
						
						<gmap-polyline v-bind:path.sync="path" v-bind:options="{ strokeColor:'#0000FF', strokeOpacity: 1, strokeWeight: 2, geodesic: false, icons: [{ icon: {path: 'M 5,15 0,0 -5,15 z', scale: 1, fillColor: 'red', strokeColor: 'red', strokeWeight: 1,fillOpacity: 0,}, offset: '0.2', repeat: '50px' }]}"></gmap-polyline>
					</gmap-map>
				</b-col>
			</b-row>
			<b-modal id="view-model" title="View DCU" ok-only @hide="setMaintenance">
				<b-container fluid>
					<b-row class="mb-1r">
						<b-col cols="4" class="text-right">IMEI :</b-col>
						<b-col cols="8">{{selectedItem.imei_no}}</b-col>
					</b-row>
					<b-row class="mb-1r">
						<b-col cols="4" class="text-right">Zone :</b-col>
						<b-col cols="8">{{selectedItem.ulb_id}}</b-col>
					</b-row>
					<b-row class="mb-1r">
						<b-col cols="4" class="text-right">Feeder Pillor No :</b-col>
						<b-col cols="8">{{selectedItem.feeder_pillar_no}}</b-col>
					</b-row>
					<b-row class="mb-1r">
						<b-col cols="4" class="text-right">Ward No :</b-col>
						<b-col cols="8">{{selectedItem.ward_no}}</b-col>
					</b-row>
				</b-container>
				<template v-slot:modal-footer="{ ok, close, hide }">
					<div v-if="$root.chkperm('page_devices','maintenance')">
						<b-button size="sm" variant="warning" v-if="selectedItem.maintenance == 0" @click="hide('maintenance_on')">Maintenance ON</b-button>
						<b-button size="sm" variant="warning" v-else @click="hide('maintenance_off')">Maintenance OFF</b-button>
					</div>
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">Ok</b-button>
				</template>
			</b-modal>

			<b-modal id="replace-model" title="Replace Panel" size="lg" ok-only @hidden="resetSelectedItem" @ok="onReplaceDevice">
				<b-container fluid>
					<b-row class="mb-1">
						<b-col>
							<b-alert show variant="secondary" class="header-title">Device Information</b-alert>
							<b-form-group label="Imei" label-for="imei-input" label-cols="4" label-size="sm" label-align-sm="right" invalid-feedback="Imei is required">
								<b-form-input id="imei-input" v-model="replaceItem.replace_imei_no" disabled></b-form-input>
							</b-form-group>
							<b-form-group label="Feeder Piller No" label-for="fp-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="fp-input" v-model="replaceItem.feeder_pillar_no" disabled></b-form-input>
							</b-form-group>
							<b-form-group label="Meter No" label-for="ccms-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="ccms-input" v-model="replaceItem.replace_meter_no" disabled></b-form-input>
							</b-form-group>
							<b-form-group label="Mobile No" label-for="ccms-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="mobile-input" v-model="replaceItem.mobile_no" disabled></b-form-input>
							</b-form-group>
						</b-col>
						<b-col>
							<b-alert show variant="secondary" class="header-title">Replace Information</b-alert>
							<b-form-group label="New CCMS" label-for="fp-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="location-input" v-model="replaceItem.new_imei_no" placeholder="New Imei no."></b-form-input>
							</b-form-group>
							<b-form-group label="New Meter" label-for="ward-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="location-input" v-model="replaceItem.new_meter_no" placeholder="New Meter no."></b-form-input>
							</b-form-group>
							<b-form-group label="Replace Date" label-for="ward-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-datepicker id="ward-input" v-model="replaceItem.replace_time" :date-format-options="{ year: 'numeric', month: 'long', day: '2-digit' }" required></b-form-datepicker>
							</b-form-group>
							<b-form-group label="Comment" label-for="ward-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-textarea v-model="replaceItem.comment" placeholder="Enter something..." rows="3" max-rows="6"></b-form-textarea>
							</b-form-group>
						</b-col>
					</b-row>
				</b-container>
				<form ref="form" @submit.stop.prevent="handleSubmit">
					
				</form>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
				</template>
			</b-modal>
			
			<b-modal id="edit-model" :title="(selectedItem.id > 0)?'Edit CCMS | DCU':'Add CCMS | DCU'" size="xl" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
				<b-container fluid>
					<b-row class="mb-1">
						<b-col>
							<b-alert show variant="secondary" class="header-title">Device Information</b-alert>
							<b-form-group label="Imei" label-for="imei-input" label-cols="4" label-size="sm" label-align-sm="right" invalid-feedback="Imei is required">
								<b-form-input id="imei-input" v-model="selectedItem.imei_no" :disabled="selectedItem.id > 0" required></b-form-input>
							</b-form-group>
							<b-form-group label="Feeder Piller No" label-for="fp-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="fp-input" v-model="selectedItem.feeder_pillar_no" :disabled="selectedItem.id > 0" required></b-form-input>
							</b-form-group>
							<b-form-group label="Device Type" label-for="title" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-select v-model="selectedItem.device_type">
									<b-form-select-option value="CCMS">CCMS</b-form-select-option>
									<b-form-select-option value="DCU">DCU</b-form-select-option>
								</b-form-select>
							</b-form-group>
							<b-form-group label="Meter Type" label-for="title" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-select v-model="selectedItem.meter_type">
									<b-form-select-option value="3P">3 Phase</b-form-select-option>
									<b-form-select-option value="1P">1 Phase</b-form-select-option>
								</b-form-select>
							</b-form-group>
							<b-form-group label="Modem Type" label-for="title" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-select v-model="selectedItem.modem_type">
									<b-form-select-option value="2G">2G</b-form-select-option>
									<b-form-select-option value="4G">4G</b-form-select-option>
								</b-form-select>
							</b-form-group>
							<b-form-group label="Inst. Phase" label-for="title" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-select v-model="selectedItem.phase">
									<b-form-select-option value="1">Phase 1</b-form-select-option>
									<b-form-select-option value="2">Phase 2</b-form-select-option>
								</b-form-select>
							</b-form-group>
							<b-form-group label="Meter No" label-for="ccms-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="ccms-input" v-model="selectedItem.device_no" :disabled="selectedItem.id > 0" required></b-form-input>
							</b-form-group>
							<b-form-group label="Mobile No" label-for="ccms-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="mobile-input" v-model="selectedItem.mobile_no" required></b-form-input>
							</b-form-group>
							<b-alert show variant="secondary" class="header-title">Map Information</b-alert>
							<b-form-group label="Latitude" label-for="load-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="load-input" v-model="selectedItem.location_lat" required></b-form-input>
							</b-form-group>
							<b-form-group label="Longitude" label-for="poles-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="poles-input" v-model="selectedItem.location_lng" required></b-form-input>
							</b-form-group>
						</b-col>
						<b-col>
							<b-alert show variant="secondary" class="header-title">Location Information</b-alert>
							<b-form-group label="State" label-for="fp-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-select v-model="selectedItem.state_id" :options="$root.state_options" @change="selectedItem.ulb_id=0" required></b-form-select>
							</b-form-group>
							<b-form-group label="ULB" label-for="title" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-select v-model="selectedItem.ulb_id">
									<b-form-select-option value="0">--- Select ULB ---</b-form-select-option>
									<b-form-select-option v-for="item in filterULB(zoneOptions)" v-bind:key="item.id" :value="item.id" >{{item.title}}</b-form-select-option>
								</b-form-select>
							</b-form-group>
							<b-form-group label="Ward" label-for="title" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-select v-model="selectedItem.ward_id">
									<b-form-select-option value="0">--- No Ward ---</b-form-select-option>
									<b-form-select-option v-for="item in filterWards()" v-bind:key="item.id" :value="item.id" >{{item.title}}</b-form-select-option>
								</b-form-select>
							</b-form-group>
							<b-form-group label="Zones" label-for="title" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-select v-model="selectedItem.zone_id">
									<b-form-select-option value="0">--- No Zone ---</b-form-select-option>
									<b-form-select-option v-for="item in filterZones()" v-bind:key="item.id" :value="item.id" >{{item.title}}</b-form-select-option>
								</b-form-select>
							</b-form-group>
							<b-form-group label="Location" label-for="ward-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="location-input" v-model="selectedItem.location" required></b-form-input>
							</b-form-group>
							<b-form-group label="Ward No" label-for="ward-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="ward-input" v-model="selectedItem.ward_no" required></b-form-input>
							</b-form-group>
							<b-form-group label="Previous Load" label-for="prev-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="prevload-input" v-model="selectedItem.previous_load" required></b-form-input>
							</b-form-group>
							<b-form-group label="Total Load" label-for="load-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="load-input" v-model="selectedItem.total_load" required></b-form-input>
							</b-form-group>
							<!--<b-form-group label="Total Connection" v-if="selectedItem.device_type === 'CCMS'" label-for="poles-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="poles-input" v-model="selectedItem.total_connection" required></b-form-input>
							</b-form-group>-->
							<b-form-group label="No of Fittings" label-for="fitting-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="fitting-input" v-model="selectedItem.no_of_fittings" required></b-form-input>
							</b-form-group>
						</b-col>
						<b-col>
							<b-alert show variant="secondary" class="header-title">LED Information</b-alert>
							<b-row>
								<b-col class="pr-0">
									<b-form-group label="18W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_18w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col class="pl-0">
									<b-form-group label="20W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_20w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							
						</b-col>
					</b-row>
				</b-container>
				<form ref="form" @submit.stop.prevent="handleSubmit">
					
				</form>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
				</template>
			</b-modal>
		
		</b-container>
		<!-- triggers="hover":target="popup_fittings_target"-->
		
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: fixed; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
		<search-sidebar></search-sidebar>
		
	</div>
	
</template>
<script>
import Header from "@/components/Header.vue";
import Search from "@/components/Search.vue";
import { Line } from 'vue-chartjs';

export default {
	name: 'Devices',
	components: {
		"top-header": Header,
		"search-sidebar": Search,
		"line-chart": Line,
	},
	beforeDestroy(){
		console.log("CLEAR INTERVAL DASHBOARD");
		clearInterval(this.interval);
	},
	sockets: {
        connect() {
			this.is_connected = 'Connected';
			console.log('socket connected');
        },
		commtoser_res(data){
			alert(data);
		},
        disconnect() {
			this.is_connected = 'Disconnected';
			console.log('socket disconnected')
		}
    },
	mounted(){
		var userinfo = this.$session.get('user_info');

		if(userinfo.role != 1 && userinfo.role != 4 && userinfo.role != 10 && userinfo.role != 11 && userinfo.role != 14){
			for(var i=this.fields.length-1; i>=0; i--){
				var field = this.fields[i];
				//console.log(i+' '+hidden_fields.indexOf(field.key)+' '+field.key);
				if(this.hidden_fields.indexOf(field.key) > -1){
					this.fields.splice(i,1);
				}
			}
		}
		
		/*if(this.$route.params.ulbareacode != 'up-meerut-meerut'){
			this.fields.splice(13,1);
		}*/
		this.$refs.livechart.renderChart({
			labels: ['January', 'February', 'March', 'April', 'May', 'June'],
			datasets: [
				{
					label: ' CCMS CONNECTED',
					borderColor: '#000099',
					backgroundColor: '#99d6ff',
					data: [8275, 5025, 6520, 3562, 5862, 6357],
					fill: false,
					lineTension: 0,
				},
				{
					label: ' CCMS ON',
					borderColor: '#009900',
					backgroundColor: '#00ff04',
					data: [7514, 9652, 4578, 3562, 8562, 1457],
					fill: false,
					lineTension: 0,
				},
				{
					label: ' LOAD',
					borderColor: '#f79800',
					backgroundColor: '#ffb642',
					data: [5236, 5025, 2365, 3562, 5862, 6357],
					fill: false,
					lineTension: 0,
				}
			]},{
			responsive: true
		});
		//this.loadulbs();
		//this.loadzones();
		//this.loadwards();
		this.initload();


	},
	data() {
		var self = this;
		
		return{
			loading: true, 
			last_sync_time: '',
			interval: '',
			zoneOptions: [],
			wards: [],
			networkfilter: 1,
			powerfilter: -1,
			current_led_load: 0,
			hidden_fields: ['imei_no', 'mobile_no', 'location_lat', 'location_lng', 'sys_meter_no', 'meter_phase_type'],
			fault_records: [],
			total_devices: 0,
			zones: [],
			path: [],
			page_title: '',
			selectedUlb: self.$route.params.ulbareacode,
			trackUrl: self.$session.get('apiurl')+'api/live-tracking',
			urltrackUrl: self.$session.get('apiurl')+'api/user-tracking',
			zonesUrl: self.$session.get('apiurl')+'api/zones',
			wardsUrl: self.$session.get('apiurl')+'api/ward-record',
			recordUrl: self.$session.get('apiurl')+'api/device-ulbs',
			insertUrl: self.$session.get('apiurl')+'api/device-insert',
			updateUrl: self.$session.get('apiurl')+'api/device-update',
			deleteUrl: self.$session.get('apiurl')+'api/device-delete',
			maintenanceUrl: self.$session.get('apiurl')+'api/device-maintenance',
			replaceUrl: self.$session.get('apiurl')+'api/replacepanel-insert',
			total_kwh: 0,
			device_on: 0,
			device_connected: 0,
			popup_fittings_target: '',
			total_load: 0,
			current_load: 0,
			total_lights: 0,
			total_light_on: 0,
			total_light_off: 0,
			total_signal_loss: 0,
			filteredrecords: [],
			info_powerfailure:0,

			total_power_cut: 0,
			total_overload: 0,
			total_manual: 0,

			records: [],
			ignorefields: ['id','sno','state_id','zone_id','ulb_id','data_fault','meter_fault','fault_time','amp_r','amp_y','amp_b','kw_r','kw_y','kw_b'],
			fields_fault: [
				{ key: 'feeder_pillar_no', label: 'F. No.', sortable: true, class: 'text-center' },
				{ key: 'location', label: 'Location', sortable: true, class: 'text-left',
					formatter: (value) => { 
						if(value != null){
							if(value.length > 30){
								return value.substring(0,30)+"...";
							}
							
						}
						return value;
					},
				},
				{ key: 'imei_no', label: 'IMEI', sortable: true, sortDirection: 'desc' },
				{ key: 'mobile_no', label: 'Mobile No', sortable: true, sortDirection: 'desc' },
				{ key: 'amp_r', label: 'AMP R',
					formatter: (value) => {
						return (value/1000).toFixed(3);
					}
				},
				{ key: 'amp_y', label: 'AMP Y',
					formatter: (value) => {
						return (value/1000).toFixed(3);
					}
				},
				{ key: 'amp_b', label: 'AMP B',
					formatter: (value) => {
						return (value/1000).toFixed(3);
					}
				},
				{ key: 'total_kw', label: 'Load', class: 'text-right', sortable: true, sortDirection: 'desc',
					formatter: (value, key, item) => { 
						if(item.meter_type === '1P'){
							return (item.kw_r/10000).toFixed(3) +' / '+(item.total_load/1000).toFixed(3);
						}
						if(item.output_status == 0 && (parseInt(item.amp_r/1000) < self.$root.correction_amp && parseInt(item.amp_y/1000) < self.$root.correction_amp && parseInt(item.amp_b/1000) < self.$root.correction_amp)){
							//value = 0;
						}
						return (value/100000).toFixed(3) +' / '+(item.total_load/1000).toFixed(3);
					},
				},
				{ key: 'supply', label: 'Power', class:"text-center", 
					formatter: (value, key, item) => {
						var supply = 'ON';
						if(item.datalength == 59){
							supply = 'OFF';
						}
						if(item.modem_type == '4G' && item.supply < 120){
							supply = 'OFF';
						}
						return supply;
					},
				},
				{ key: 'door_status', label: 'Door Status' },
				{ key: 'meter_phase_type', label: 'P' },
				{ key: 'output_status', label: 'Output' , 
					formatter: (value) => {
						//if(value == 0){
						//	return 'OFF';
						//}
						return value;
					},
				},
				{ key: 'mode', label: 'Mode', sortable: true, class: 'text-center' },
				{ key: 'update_time', label: 'TimeStamp', 
					formatter: (value, key, item) => {
						/*if(item.data_fault == 1){
							return self.$moment(item.fault_time).format('DD-MM-YYYY HH:mm:ss');
						}*/
						if(item.update_time == "" || item.update_time == "00-00-0000 00:00"){
							return '-n/a-';
						}
						return self.$moment(item.update_time).format('DD-MM-YYYY HH:mm');
					},
				},
				{ key: 'connection_status', label: 'Network Status', sortable: true,
					formatter: (value, key, item) => {
						if(item.datalength == 0){
							return 3;
						}
						if(item.datalength != 59 && item.datalength != 210 && item.datalength != 236){
							return 2;
						}
						return value;
					}
				},
				{ key: 'actions', label: 'Actions', class:'text-right', 'extra': 1 }
			],
			fields: [
				{ key: 'data_stamp', label: 'Data Stamp.', sortable: true, class: 'text-left',
					formatter: (value) => {
						return self.$moment(value).format('DD-MM-YYYY HH:mm');
					}
				},
				{ key: 'feeder_pillar_no', label: 'F. No.', sortable: true, class: 'text-center' },
				{ key: 'location', label: 'Location', sortable: true, class: 'text-left',
					formatter: (value) => { 
						if(value != null){
							if(value.length > 30){
								return value.substring(0,30)+"...";
							}
							
						}
						return value;
					},
				},
				{ key: 'imei_no', label: 'IMEI', sortable: true, sortDirection: 'desc' },
				{ key: 'mobile_no', label: 'Mobile No', sortable: true, sortDirection: 'desc' },
				{ key: 'phase', label: 'PH', sortable: true, sortDirection: 'desc' },
				{ key: 'no_of_fittings', label: 'Fittings', sortable: false,	sortByFormatted: true, filterByFormatted: true },
				{ key: 'total_load', label: 'Physical Load', class: 'text-right',
					formatter: (value) => { 
						return (value/1000).toFixed(3);
					},
				},
				{ key: 'total_kw', label: 'Actual Load', class: 'text-right', sortable: true, sortDirection: 'desc',
					formatter: (value, key, item) => { 
						if(item.meter_type === '1P'){
							return (item.kw_r/10000).toFixed(3);
						}
						if(item.output_status == 0 && (parseInt(item.amp_r/1000) < self.$root.correction_amp && parseInt(item.amp_y/1000) < self.$root.correction_amp && parseInt(item.amp_b/1000) < self.$root.correction_amp)){
							value = 0;
						}
						return (value/100000).toFixed(3);
					},
				},
				{ key: 'supply', label: 'Power', class:"text-center", 
					formatter: (value, key, item) => {
						var supply = 'ON';
						if(item.datalength == 59){
							supply = 'OFF';
						}
						if(item.modem_type == '4G' && item.supply < 120){
							supply = 'OFF';
						}
						return supply;
					},
				},
				{ key: 'door_status', label: 'Door Status' },
				{ key: 'meter_phase_type', label: 'P' },
				{ key: 'location_lat', label: 'Latitude' },
				{ key: 'location_lng', label: 'Longitude' },
				{ key: 'sys_meter_no', label: 'MS', sortable: true, 
					formatter: (value, key, item) => {
						if(value == item.device_no){
							return 0;
						}
						return 1;
					},
				},
				
				{ key: 'output_status', label: 'Output' , 
					formatter: (value) => {
						//if(value == 0){
						//	return 'OFF';
						//}
						return value;
					},
				},
				{ key: 'overload', label: 'OL', sortable: true, class: 'text-right',
					formatter: (value, key, item) => {
						var fault = 0;
						if(item.meter_type === '1P'){
							fault = 100*((item.kw_r/1000) - (item.total_load/1000))/(item.total_load/1000) ;
						}else{
							fault = 100*((item.total_kw/100000) - (item.total_load/1000))/(item.total_load/1000);
						}
						return fault.toFixed(1);		
					},
				},
				{ key: 'underload', label: 'UL', sortable: true, class: 'text-right',
					formatter: (value, key, item) => {
						var fault = 0;
						if(item.meter_type === '1P'){
							fault = 100*((item.total_load/1000) - (item.kw_r/1000))/(item.total_load/1000) ;
						}else{
							fault = 100*((item.total_load/1000) - (item.total_kw/100000))/(item.total_load/1000);
						}
						if(fault>=99.9){
							fault = 100;
						}
						return fault.toFixed(1);		
					},
				},
				{ key: 'mode', label: 'Mode', sortable: true, class: 'text-center' },
				{ key: 'update_time', label: 'TimeStamp', 
					formatter: (value, key, item) => {
						/*if(item.data_fault == 1){
							return self.$moment(item.fault_time).format('DD-MM-YYYY HH:mm:ss');
						}*/
						if(item.update_time == "" || item.update_time == "00-00-0000 00:00"){
							return '-n/a-';
						}
						return self.$moment(item.update_time).format('DD-MM-YYYY HH:mm');
					},
				},
				{ key: 'connection_status', label: 'Network Status', sortable: true,
					formatter: (value, key, item) => {
						if(item.datalength == 0){
							return 3;
						}
						if(item.datalength != 59 && item.datalength != 210 && item.datalength != 236){
							return 2;
						}
						return value;
					}
				},
				{ key: 'actions', label: 'Actions', class:'text-right', 'extra': 1 }
			],
			totalRows: 1,
			currentPage: 1,
			selectedfilter: 'CONNECT',
			networkOptions: [{text:'All', value:-1}, {text:'Connected', value:1}, {text:'Disconnected', value:0}, {text:'Data Fault', value:2}, {text:'Pending', value:3}],
			powerOptions: [{text:'All', value:-1}, {text:'ON', value:1}, {text:'OFF', value:0}, {text:'Power Failure', value:2}],
			filteroptions: [{text:'All', value:'ALL'}, {text:'Connected', value:'CONNECT'}, {text:'Disconnected', value:'DISCONNECT'}, {text:'CCMS ON', value:'CCMSON'}, {text:'CCMS OFF', value:'CCMSOFF'}, {text:'Manual ON', value:'MANUAL'}, {text:'Power Failure', value:'PWROFF'}, {text:'Meter Fault', value:'DATAFLT'}, {text:'Pending', value:'PENDING'} ],
			pageOptions: [10, 20, 50, 100, 500, 1000, 2000],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {},
			replaceItem: {},
			emptyItem: {
				id: 0,
				imei_no: '',
				zone_id: 0,
				state_id: 0,
				ulb_id: 0,
				ward_id: 0,
				feeder_pillar_no: '',
				modem_type: '2G',
				ward_no: '',
				ccms_no: '',
				total_load: '',
				total_connection: 0,
				no_of_poles: 0,
				no_of_fittings: 0,
				location_lat: '',
				location_lng: '',
				meter_type: '3P',
				phase: 1,
				led_18w: 0,
				led_20w: 0,
				led_24w: 0,
				led_28w: 0,
				led_32w: 0,
				led_35w: 0,
				led_40w: 0,
				led_45w: 0,
				led_50w: 0,
				led_60w: 0,
				led_70w: 0,
				led_72w: 0,
				led_75w: 0,
				led_80w: 0,
				led_90w: 0,
				led_96w: 0,
				led_100w: 0,
				led_110w: 0,
				led_120w: 0,
				led_130w: 0,
				led_140w: 0,
				led_150w: 0,
				led_190w: 0,
				led_200w: 0,
				led_250w: 0,
				led_400w: 0,
				maintenance: 0
			},
			center: { lat: 0, lng: 0 },
			markers: [],
			markers1: [],
			center2: { lat: 0, lng: 0 },
			markers2: [],
			places: [],
			currentPlace: null,
			infoWindowPos: null,
			infoWindowOpen: false,
			currentMarkerIndex: null,
			zoom: 10,
			infoOptions: {
				content: '',
				pixelOffset: {
					width: 0,
					height: -35
				}
			},
			popup_fittings: {}
		};
	},
	methods: {
		mapdistance(mk1, mk2) {
			var R = 3958.8; // Radius of the Earth in miles
			var rlat1 = mk1.position.lat * (Math.PI/180); // Convert degrees to radians
			var rlat2 = mk2.position.lat * (Math.PI/180); // Convert degrees to radians
			var difflat = rlat2-rlat1; // Radian difference (latitudes)
			var difflon = (mk2.position.lng - mk1.position.lng) * (Math.PI/180); // Radian difference (longitudes)

			var d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat/2)*Math.sin(difflat/2)+Math.cos(rlat1)*Math.cos(rlat2)*Math.sin(difflon/2)*Math.sin(difflon/2)));
			return d;
		},
		sendCommand(cmd, imei){
			var o = new Object();
			o.imei = imei;
			o.command = cmd;

			if(this.$socket.connected){
				console.log("CONNECTED AND LOADING DATA");
				
				this.$socket.emit('commtoser', o);
			}
		},
		showFittings(item, target){
			console.log(item.no_of_fittings+' '+target.id)
			this.popup_fittings_target = target.id;
			this.popup_fittings = item.no_of_fittings;
			//this.$refs.popover.$emit('open');
			this.$root.$emit('bv::show::popover', target.id);
			console.log("SHOW FITTINGS");
			
			
			//this.$refs.popover.$emit('show', target.id)
		},
		hideFittings(){
			console.log("HIDE FITTINGS");
			this.popup_fittings_target = "";
			this.$refs.popover.$emit('close');
		},
		onFilterChange(){
			this.filteredrecords = this.filterChange(this.records);
			this.totalRows = this.filteredrecords.length;
			this.currentPage = 1;
		},
		onFilterDevices(){
			this.filteredrecords = this.filterDevices(this.records);
			this.totalRows = this.filteredrecords.length;
			this.currentPage = 1;
		},
		filterWards(){
			var self = this;
			return self.wards.filter(function (item) {
				return item.ulb_id  == self.selectedItem.ulb_id;
			})
		},
		filterZones(){
			var self = this;
			return self.zones.filter(function (item) {
				return item.ulb_id  == self.selectedItem.ulb_id;
			})
		},
		filterChange(devices){
			var self = this;
			return devices.filter(function (d) {
				if(self.selectedfilter == 'ALL'){
					return d;
				}
				if(self.selectedfilter == 'CONNECT'){
					if(d.connection_status == 1 && d.datalength > 0){
						return d;
					}
				}
				if(self.selectedfilter == 'DISCONNECT'){
					if(d.connection_status == 0 && d.datalength > 0){
						return d;
					}
				}
				
				if(self.selectedfilter == 'CCMSON'){
					if(d.connection_status == 1 && d.output_status == 1){
						return d;
					}
				}
				if(self.selectedfilter == 'CCMSOFF'){
					if(d.connection_status == 1 && d.output_status == 0){
						return d;
					}
				}
				if(self.selectedfilter == 'MANUAL'){
					if(d.connection_status == 1 && d.mode == 1){
						return d;
					}
				}
				
				if(self.selectedfilter == 'PWROFF'){
					if(d.connection_status == 1 && d.supply == 0){
						return d;
					}
				}
				if(self.selectedfilter == 'DATAFLT'){
					if(d.connection_status == 1 && d.datalength != 59 && d.datalength != 210 && d.datalength != 0){
						return d;
					}
				}
				if(self.selectedfilter == 'PENDING'){
					if(d.datalength == 0){
						return d;
					}
				}
			});
		},
		filterDevices(devices){
			var self = this;
			return devices.filter(function (d) {
				var valid_network = false;
				var valid_power = false;
				


				if(self.networkfilter < 0){
					valid_network = true;
				}else if(self.networkfilter == 0){ // disconnected 
					if(d.connection_status == 0 && d.datalength > 0){
						valid_network = true;
					}
				}else if(self.networkfilter == 1){ // connected 
					if(d.connection_status == 1 && d.datalength > 0){
						valid_network = true;
					}
				}else if(self.networkfilter == 2){ // Data Fault 
					if(d.datalength != 59 && d.datalength != 210 && d.datalength != 0){
						valid_network = true;
					}
				}else if(self.networkfilter == 3){ // Pending 
					if(d.datalength == 0){
						valid_network = true;
					}
				}

				if(self.powerfilter < 0){
					valid_power = true;
				}else if(self.powerfilter == 0){ // OFF 
					if(d.output_status == 0){
						valid_power = true;
					}
				}else if(self.powerfilter == 1){ // ON 
					if(d.output_status == 1){
						valid_power = true;
					}
				}else if(self.powerfilter == 2){ // Power Failure 
					if(d.datalength == 59){
						valid_power = true;
					}
				}
				
				if(valid_network && valid_power){
					return d;
				}
			});
		},
		updateTotalLoad(){
			var total_load = 0;
			if(parseInt(this.selectedItem.led_18w) > 0){
				total_load += parseInt(this.selectedItem.led_18w) * 18;
			}
			if(parseInt(this.selectedItem.led_20w) > 0){
				total_load += parseInt(this.selectedItem.led_20w) * 20;
			}
			if(parseInt(this.selectedItem.led_24w) > 0){
				total_load += parseInt(this.selectedItem.led_24w) * 24;
			}
			if(parseInt(this.selectedItem.led_32w) > 0){
				total_load += parseInt(this.selectedItem.led_32w) * 32;
			}
			if(parseInt(this.selectedItem.led_35w) > 0){
				total_load += parseInt(this.selectedItem.led_35w) * 35;
			}
			if(parseInt(this.selectedItem.led_40w) > 0){
				total_load += parseInt(this.selectedItem.led_40w) * 40;
			}
			if(parseInt(this.selectedItem.led_45w) > 0){
				total_load += parseInt(this.selectedItem.led_45w) * 45;
			}
			if(parseInt(this.selectedItem.led_50w) > 0){
				total_load += parseInt(this.selectedItem.led_50w) * 50;
			}
			if(parseInt(this.selectedItem.led_60w) > 0){
				total_load += parseInt(this.selectedItem.led_60w) * 60;
			}
			if(parseInt(this.selectedItem.led_70w) > 0){
				total_load += parseInt(this.selectedItem.led_70w) * 70;
			}
			if(parseInt(this.selectedItem.led_72w) > 0){
				total_load += parseInt(this.selectedItem.led_72w) * 72;
			}
			if(parseInt(this.selectedItem.led_75w) > 0){
				total_load += parseInt(this.selectedItem.led_75w) * 75;
			}
			if(parseInt(this.selectedItem.led_80w) > 0){
				total_load += parseInt(this.selectedItem.led_80w) * 80;
			}
			if(parseInt(this.selectedItem.led_90w) > 0){
				total_load += parseInt(this.selectedItem.led_90w) * 90;
			}
			if(parseInt(this.selectedItem.led_100w) > 0){
				total_load += parseInt(this.selectedItem.led_100w) * 100;
			}
			if(parseInt(this.selectedItem.led_110w) > 0){
				total_load += parseInt(this.selectedItem.led_110w) * 110;
			}
			if(parseInt(this.selectedItem.led_120w) > 0){
				total_load += parseInt(this.selectedItem.led_120w) * 120;
			}
			if(parseInt(this.selectedItem.led_130w) > 0){
				total_load += parseInt(this.selectedItem.led_130w) * 130;
			}
			if(parseInt(this.selectedItem.led_140w) > 0){
				total_load += parseInt(this.selectedItem.led_140w) * 140;
			}
			if(parseInt(this.selectedItem.led_150w) > 0){
				total_load += parseInt(this.selectedItem.led_150w) * 150;
			}
			if(parseInt(this.selectedItem.led_190w) > 0){
				total_load += parseInt(this.selectedItem.led_190w) * 190;
			}
			if(parseInt(this.selectedItem.led_200w) > 0){
				total_load += parseInt(this.selectedItem.led_200w) * 200;
			}
			if(parseInt(this.selectedItem.led_250w) > 0){
				total_load += parseInt(this.selectedItem.led_250w) * 250;
			}
			if(parseInt(this.selectedItem.led_400w) > 0){
				total_load += parseInt(this.selectedItem.led_400w) * 400;
			}
			this.selectedItem.total_load = total_load;
			
			this.selectedItem.no_of_fittings = parseInt(this.selectedItem.led_18w) + parseInt(this.selectedItem.led_24w) + parseInt(this.selectedItem.led_35w) + parseInt(this.selectedItem.led_45w) + parseInt(this.selectedItem.led_70w) + parseInt(this.selectedItem.led_75w) + parseInt(this.selectedItem.led_110w) + parseInt(this.selectedItem.led_140w) + parseInt(this.selectedItem.led_190w);
		},
		setMaintenance(val){
			var self = this;
			var maintenance_flag = -1;
			if(val.trigger == "maintenance_on"){
				maintenance_flag = 1;
			}
			else if(val.trigger == "maintenance_off"){
				maintenance_flag = 0;
			}

			if(maintenance_flag >= 0){
				var submitdata = new Object();
				submitdata.feeder_pillar_no = self.selectedItem.feeder_pillar_no;
				submitdata.maintenance = maintenance_flag;

				self.loading = true;
				//bvModalEvt.preventDefault();

				self.axios.post(self.maintenanceUrl, {
					accesskey: self.$session.get('access_key'),
					data: submitdata
				})
				.then(function (response) {
					if(response.data.error == 0 || response.data.error == '0'){
						self.$bvModal.hide('view-model');
						self.$bvToast.toast(response.data.message, {
							title: 'Status',
							toaster: 'b-toaster-bottom-right',
							autoHideDelay: 5000,
							variant: 'warning',
							solid: true,
							appendToast: true
						});
						self.initload();
					}
					
				})
				.catch(function (error) {
					alert(error);
				});
			}
		},
		toogleMarkerInfoWindow(marker, index){
			this.infoWindowPos = marker.position;
			this.infoOptions.content = marker.infotext;
			if(this.currentMarkerIndex == index){
				this.infoWindowOpen = !this.infoWindowOpen;
			}else{
				this.infoWindowOpen = true;
				this.currentMarkerIndex = index;
			}
		},
		addMarker(lat, lng, infotext, iconurl) {
			const marker = {
				lat: lat,
				lng: lng
			};
			return { position: marker, infotext: infotext, icon: {url:iconurl,size: {width: 20, height: 28, f: 'px', b: 'px'}, scaledSize: {width: 20, height: 28, f: 'px', b: 'px',}} };
			//this.markers.push({ position: marker, infotext: infotext, icon: {url:iconurl} });
			//this.places.push(this.currentPlace);
			//this.center = marker;
			//this.currentPlace = null;
		},
		addMarker2(lat, lng, infotext, iconurl) {
			const marker = {
				lat: lat,
				lng: lng
			};
			//this.markers.push({ position: marker, infotext: infotext, icon: {url:iconurl,size: {width: 60, height: 90, f: 'px', b: 'px'}, scaledSize: {width: 30, height: 45, f: 'px', b: 'px',}} });
			this.markers.push({ position: marker, infotext: infotext, icon: {url:iconurl} });
			//this.places.push(this.currentPlace);
			this.center = marker;
			this.currentPlace = null;
		},
		filterZone: function (items) {
			var self = this;
			return items.filter(function (item) {
				if(item.parent ==0){
					return item.ulb_id  == self.selectedItem.ulb_id;
				}
			})
		},
		filterULB: function (items) {
			var self = this;
			return items.filter(function (item) {
				return item.state == self.selectedItem.state_id;
			})
		},
		showAddModal(){
			var self = this;
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.zoneOptions.forEach(function(field){
				if(field.areacode == self.selectedUlb){
					self.selectedItem.state_id = field.state;
					if(field.parent > 0){
						self.selectedItem.zone_id = field.parent;
					}
					if(field.parent > 0){
						self.selectedItem.ulb_id = field.id;
					}
				}
			});
			this.$root.$emit('bv::show::modal', 'edit-model');
		},
		showUpdateModal(item, index, button) {
			this.selectedItem = Object.assign({}, item);
			this.$root.$emit('bv::show::modal', 'edit-model', button)
		},
		showViewModal(item, button){
			this.selectedItem = Object.assign({}, item);
			this.$root.$emit('bv::show::modal', 'view-model', button);
		},
		showReplaceModal(item, button){
			this.replaceItem = {
				replace_imei_no: item.imei_no,
				replace_meter_no: item.device_no,
				feeder_pillar_no: item.feeder_pillar_no,
				new_imei_no: '',
				new_meter_no: '',
				mobile_no: item.mobile_no,
				replace_time: '',
				comment: ''
			};
			this.$root.$emit('bv::show::modal', 'replace-model', button);
		},
		showDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete device.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						deleteid: item.id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		onReplaceDevice(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			
			self.axios.post(self.replaceUrl, {
				accesskey: self.$session.get('access_key'),
				data: self.replaceItem
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('replace-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		modalSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			var submitUrl = "";
			if(self.selectedItem.id == 0){
				submitUrl = self.insertUrl;
			}else{
				submitUrl = self.updateUrl;
			}
			
			self.axios.post(submitUrl, {
				accesskey: self.$session.get('access_key'),
				data: self.selectedItem
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('edit-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}else{
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'danger',
						solid: true,
						appendToast: true
					});
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		
		

		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		loadzones(){
			var self = this;
			
			self.axios.post(self.zonesUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.zones = response.data.result;
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		loadulbs(){
			var self = this;
			
			self.axios.post(self.ulbsUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.zoneOptions = response.data.result;
					self.zoneOptions.forEach(function(field){
						//if(field.state == 'in-mh'){
							if(field.areacode == self.selectedUlb){
								self.zoneOptions.forEach(function(field2){
									if(field2.id == field.parent){
										self.page_title = field.title;
										return;
									}
								});
							}
						//}
					});
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		loadwards(){
			var self = this;
			
			self.axios.post(self.wardsUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.wards = response.data.result;
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		/*initload(){
			var self = this;

			const dt = new Date();
			let tm = dt.getTime();
			
			self.axios.post(self.trackUrl+'?'+tm, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result.records;
					self.loading = false;
					self.totalRows = self.records.length;

					self.last_sync_time = self.$moment(response.data.result.time).format('DD-MM-YYYY HH:mm:ss');

					self.total_users = 0;
					self.total_users_connected = 0;
					self.total_users_disconencted = 0;
					self.total_users_offline = 0;

					self.records.forEach(function(field){
						self.total_lights += field.no_of_fittings;
						
						self.total_load += parseInt(field.total_load);

						if(field.kwh && field.kwh != 'NaN'){
							self.total_kwh += parseInt(field.kwh);
						}


						var curdatetime = self.$moment(response.data.result.time);
						var conn_status = 1;
						var dbdatetime = '';
						var duration = '';
						var minutes = '';
						
						
						if(field.update_time == "" || field.update_time == null || field.update_time == 'null' || field.update_time.length < 10){
							conn_status = 3;
						}else{
							dbdatetime = self.$moment(field.update_time);
							
							if(curdatetime > dbdatetime){
								duration = self.$moment.duration(curdatetime.diff(dbdatetime));
							}else{
								duration = self.$moment.duration(dbdatetime.diff(curdatetime));
							}
							minutes = duration.asMinutes();
							var disconnection_time = self.$session.get('disconnection_time');
							if(minutes < disconnection_time){
								conn_status = 1;
							}else{
								conn_status = 0;
							}
						}
						
						field.connection_status = conn_status;

						//item.datalength != 59 && item.datalength != 210 && item.datalength != 236
						//if(d.connection_status == 1 && d.datalength != 59 && d.datalength != 210 && d.datalength != 0){

						if(conn_status == 1 && (field.supply < 120 || field.supply == 0)){
							self.total_power_cut += 1;
						}

						if(conn_status == 1){
							self.device_connected += 1;
						}
						if(field.connection_status == 1 && field.output_status == 1 && conn_status == 1){
							self.device_on += 1;
							self.total_light_on += field.no_of_fittings;
						}
						if(field.connection_status == 1 && field.output_status == 0 && conn_status == 1){
							self.total_light_off += field.no_of_fittings;
						}
						if(conn_status == 0){
							self.total_signal_loss += field.no_of_fittings;
						}

					});
					self.filteredrecords = self.filterChange(self.records);//self.filterDevices(self.records);
					

					var min_lat = 100;
					var min_lng = 100;
					var max_lat = 0;
					var max_lng = 0;

					self.markers = [];
					self.markers2 = [];
					var geoloc = [];
					//if(self.markers.length == 0 || self.records.length != self.markers.length){
						for (var i = 0; i < self.records.length; i++) {
							var d = self.records[i];

                            var latitude = parseFloat(d.latitude);
                            var longitude = parseFloat(d.longitude);


                            if(latitude > 0 && longitude > 0){    
                                var jsondata = JSON.parse(d.data);
                                var speed = jsondata.speed;
                                if(speed == null){
                                    speed = 0;
                                }
                                
                                var msg = '<b>CCMS ID: '+d.user_id+'</b><br><b>Location</b> : '+d.location+'<br><b>Latitude :</b> '+d.latitude+'<br><b>Longitude :</b> '+d.longitude+'<br><b>Speed :</b> '+speed+'<br><b>Update Time :</b> '+self.$moment(d.update_time).format('DD-MM-YYYY HH:mm:ss');

                                min_lat = Math.min(latitude, min_lat);
                                min_lng = Math.min(longitude, min_lng);

                                max_lat = Math.max(latitude, max_lat);
                                max_lng = Math.max(longitude, max_lng);

                                var blueurl = "https://www.fablurs.com/flag-blue.png";
                                var redurl = "https://www.fablurs.com/flag-red.png";
                                var greenurl = "https://www.fablurs.com/flag-green.png";
                                var iconurl = blueurl;
                                if(d.connection_status == 1){
                                    if(d.output_status == 1){
                                        iconurl = greenurl;
                                    }else{
                                        iconurl = redurl;
                                    }
                                }
                                var mr = self.addMarker(latitude, longitude, msg, iconurl);
                                
								geoloc.push(mr);
                            }
						}
						self.markers = geoloc;
						if(!self.interval){
							self.center = { lat: min_lat + (max_lat - min_lat)/2, lng: min_lng + (max_lng - min_lng)/2 };
						}
					//}
					self.interval = setTimeout(self.initload, self.$root.reload_duration);
				}else{
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				self.interval = setTimeout(self.initload, self.$root.reload_duration);
				console.log(error);
			});
			//alert('login '+self.email+" "+self.password);
		},*/
		initload(){
			var self = this;

			const dt = new Date();
			let tm = dt.getTime();
			
			self.axios.post(self.urltrackUrl+'?'+tm, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result.records;
					self.loading = false;
					self.totalRows = self.records.length;

					self.last_sync_time = self.$moment(response.data.result.time).format('DD-MM-YYYY HH:mm:ss');

					self.total_users = 0;
					self.total_users_connected = 0;
					self.total_users_disconencted = 0;
					self.total_users_offline = 0;

					self.records.forEach(function(field){
						self.total_lights += field.no_of_fittings;
						
						self.total_load += parseInt(field.total_load);

						if(field.kwh && field.kwh != 'NaN'){
							self.total_kwh += parseInt(field.kwh);
						}


						var curdatetime = self.$moment(response.data.result.time);
						var conn_status = 1;
						var dbdatetime = '';
						var duration = '';
						var minutes = '';
						
						
						if(field.update_time == "" || field.update_time == null || field.update_time == 'null' || field.update_time.length < 10){
							conn_status = 3;
						}else{
							dbdatetime = self.$moment(field.update_time);
							
							if(curdatetime > dbdatetime){
								duration = self.$moment.duration(curdatetime.diff(dbdatetime));
							}else{
								duration = self.$moment.duration(dbdatetime.diff(curdatetime));
							}
							minutes = duration.asMinutes();
							var disconnection_time = self.$session.get('disconnection_time');
							if(minutes < disconnection_time){
								conn_status = 1;
							}else{
								conn_status = 0;
							}
						}
						
						field.connection_status = conn_status;

						//item.datalength != 59 && item.datalength != 210 && item.datalength != 236
						//if(d.connection_status == 1 && d.datalength != 59 && d.datalength != 210 && d.datalength != 0){

						if(conn_status == 1 && (field.supply < 120 || field.supply == 0)){
							self.total_power_cut += 1;
						}

						if(conn_status == 1){
							self.device_connected += 1;
						}
						if(field.connection_status == 1 && field.output_status == 1 && conn_status == 1){
							self.device_on += 1;
							self.total_light_on += field.no_of_fittings;
						}
						if(field.connection_status == 1 && field.output_status == 0 && conn_status == 1){
							self.total_light_off += field.no_of_fittings;
						}
						if(conn_status == 0){
							self.total_signal_loss += field.no_of_fittings;
						}

					});
					self.filteredrecords = self.filterChange(self.records);//self.filterDevices(self.records);
					

					var min_lat = 100;
					var min_lng = 100;
					var max_lat = 0;
					var max_lng = 0;

					self.markers = [];
					self.markers1 = [];
					self.markers2 = [];

					self.path = [];

					var start_marker = '';
					var distance = 0;
					var geoloc = [];
					//if(self.markers.length == 0 || self.records.length != self.markers.length){
						for (var i = 0; i < self.records.length; i++) {
							var d = self.records[i];

                            var latitude = parseFloat(d.lat);
                            var longitude = parseFloat(d.lng);


                            if(latitude > 0 && longitude > 0){    
                                var jsondata = JSON.parse(d.data);
                                var speed = jsondata.speed;
                                if(speed == null){
                                    speed = 0;
                                }
                                
                                var msg = '<b>CCMS ID: '+d.user_id+'</b><br><b>Location</b> : '+d.location+'<br><b>Latitude :</b> '+d.latitude+'<br><b>Longitude :</b> '+d.longitude+'<br><b>Speed :</b> '+speed+'<br><b>Update Time :</b> '+self.$moment(d.update_time).format('DD-MM-YYYY HH:mm:ss');

                                min_lat = Math.min(latitude, min_lat);
                                min_lng = Math.min(longitude, min_lng);

                                max_lat = Math.max(latitude, max_lat);
                                max_lng = Math.max(longitude, max_lng);

                                var blueurl = "https://www.fablurs.com/flag-blue.png";
                                var redurl = "https://www.fablurs.com/flag-red.png";
                                var greenurl = "https://www.fablurs.com/flag-green.png";
                                var iconurl = blueurl;
                                if(i == 0){
									self.markers1.push(self.addMarker(latitude, longitude, msg, greenurl));
								}else if(i == self.records.length-1){
									self.markers1.push(self.addMarker(latitude, longitude, msg, redurl));
								}
                                var mr = self.addMarker(latitude, longitude, msg, iconurl);

								if(start_marker){
									distance += self.mapdistance(start_marker, mr);
								}
								
								start_marker = mr;
                                
								geoloc.push(mr);
                            }
							self.path.push({'lat': latitude, 'lng': longitude});
						}
						self.markers = geoloc;
						
						if(!self.interval){
							self.center = { lat: min_lat + (max_lat - min_lat)/2, lng: min_lng + (max_lng - min_lng)/2 };
						}

						console.log(distance * 1.60934);
					//}

					//new MarkerClusterer({ self.markers, self.$refs.refmap });

					self.interval = setTimeout(self.initload, self.$root.reload_duration);
				}else{
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				self.interval = setTimeout(self.initload, self.$root.reload_duration);
				console.log(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		downloadcsv(){
			var self = this;
			var header = new Array();
			var finalarr = new Array();
			var data = [...self.filteredrecords];

			var userinfo = this.$session.get('user_info');

			//data[0].forEach(function(item){
				for (const [key] of Object.entries(data[0])) {
					if(self.ignorefields.indexOf(key) < 0){

						if(userinfo.role != 1 && userinfo.role != 4 && userinfo.role != 10 && userinfo.role != 11){
							if(self.hidden_fields.indexOf(key) < 0){
								header.push(key);
							}
						}else{
							header.push(key);
						}

					}
				}
			//});
			
			finalarr.push(header);
			data.forEach(function(row){
				var dataarr = new Array();
				for (const [key,value] of Object.entries(row)) {
					if(self.ignorefields.indexOf(key) < 0){

						if(userinfo.role != 1 && userinfo.role != 4 && userinfo.role != 10 && userinfo.role != 11){
							if(self.hidden_fields.indexOf(key) < 0){
								
								if(key == 'total_load'){
									if(row.meter_type === '1P'){
										dataarr.push((row.kw_r/10000).toFixed(3));
									}else{
										dataarr.push((value/1000).toFixed(3));
									}
								}else if(key == 'total_kw'){
									if(row.meter_type === '1P'){
										dataarr.push((value/10000).toFixed(3));
									}else{
										dataarr.push((value/100000).toFixed(3));
									}
								}else if(key === 'location'){
									dataarr.push(value.replace(","," "));
								}else if(key === 'output_status'){
									if(value == 1){
										dataarr.push('ON');
									}else{
										dataarr.push('OFF');
									}
								}else{
									dataarr.push(value);
								}

							}
						}else{
							if(key == 'total_load'){
								if(row.meter_type === '1P'){
									dataarr.push((row.kw_r/10000).toFixed(3));
								}else{
									dataarr.push((value/1000).toFixed(3));
								}
							}else if(key == 'total_kw'){
								if(row.meter_type === '1P'){
									dataarr.push((value/1000).toFixed(3));
								}else{
									dataarr.push((value/100000).toFixed(3));
								}
							}else if(key === 'location'){
								if(value == ''){
									dataarr.push("");	
								}else{
									dataarr.push(value.replace(","," "));
								}
							}else if(key === 'output_status'){
								if(value == 1){
									dataarr.push('ON');
								}else{
									dataarr.push('OFF');
								}
							}else{
								dataarr.push(value);
							}
						}

						
					}
				}
				finalarr.push(dataarr);
			});
			
			let csvContent = "data:text/csv;charset=utf-8," 
			+ finalarr.map(e => e.join(",")).join("\n");

			var encodedUri = encodeURI(csvContent);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
			link.setAttribute("download", "device_report.csv");
			document.body.appendChild(link); // Required for FF

			link.click();
		}
	}
}
</script>
<style>
html{
	min-height: 100%;
}
body{
	background-color: '#FFF' !important;
	background-image: none !important;
}
.table{
	font-size: small;
}
.table .btn{
	font-size: 12px;
	font-weight: 600;
}
.table td, .table th{
	vertical-align: middle;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
.header-title{
	padding: 0.3rem 1.25rem;
}

.badge{
	font-size: 85%;
}

.text-sm{
	font-size: 13px;
}
.text-md{
	font-size: 16px;
}
.text-lg{
	font-size: 18px;
}
</style>